import { Component, ChangeDetectionStrategy, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

interface SpendingCategory {
  name: string;
  amount: number;
  color: string;
}

@Component({
  selector: 'app-spending-breakdown',
  templateUrl: './spending-breakdown.component.html',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpendingBreakdownComponent {
  hoveredCategory = signal<string | null>(null);

  spendingData = signal<SpendingCategory[]>([
    { name: 'Shopping', amount: 850.50, color: 'text-blue-500' },
    { name: 'Groceries', amount: 420.75, color: 'text-green-500' },
    { name: 'Transport', amount: 150.00, color: 'text-yellow-500' },
    { name: 'Bills', amount: 310.25, color: 'text-red-500' },
  ]);

  totalSpending = computed(() => this.spendingData().reduce((acc, item) => acc + item.amount, 0));

  chartSegments = computed(() => {
    const data = this.spendingData();
    const total = this.totalSpending();
    let cumulativePercent = 0;

    return data.map(item => {
      const percent = (item.amount / total) * 100;
      const segment = {
        ...item,
        percent,
        strokeDasharray: `${percent} ${100 - percent}`,
        strokeDashoffset: -cumulativePercent
      };
      cumulativePercent += percent;
      return segment;
    });
  });

  onMouseEnter(categoryName: string): void {
    this.hoveredCategory.set(categoryName);
  }

  onMouseLeave(): void {
    this.hoveredCategory.set(null);
  }
}
